module.exports = __webpack_public_path__ + "static/media/Semele.b81ee673.jpg";